import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
} from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import constants from '../../../utility/constants';
import { AuctionService, LoaderService } from '../../../services';
import { ImageValidators } from '../../../core/validators/image-validators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { GetAuctionStep2 } from '../../../models';
import messages from '../../../utility/messages';
import {
  AuctionImageUploadService,
  ImageFile,
} from '../../../services/auction-image-upload.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-add-auction-step2',
  templateUrl: './add-auction-step2.component.html',
  styleUrls: ['./add-auction-step2.component.css'],
})
export class AddAuctionStep2Component implements OnInit {
  @Input('isEditMode') editMode: boolean;
  @Input('auctionStatus') auctionStatus: number;
  @Input('auctionId') auctionId: number;
  @Output('goToStep') step: EventEmitter<number> = new EventEmitter();
  showView = false;

  // step 2 form
  createAuctionForm2: FormGroup;

  submitted: boolean = false;

  // edit Directory
  addEditDeleteSliderImages: Array<{ id: number; name: File | string }>;
  addEditDeletePhotoGallery: Array<{ id: number; name: File | string }>;

  //image settings
  coverPhotoSize: string;
  coverPhotoFormat: string;
  clientLogoSize: string;
  clientLogoFormat: string;
  sliderImageSize: string;
  sliderImageFormat: string;
  photoGallerySize: string;
  photoGalleryFormat: string;

  //images with thumbnails
  coverPhotoString: string;
  clientLogoString: string;

  sliderImages: Array<any> = [];
  galleryImages: Array<any> = [];

  resultantSliderImages: ImageFile[] = [];
  resultantGalleryImages: ImageFile[] = [];

  photoGalleryAsset: number;
  sliderImageAsset: number;

  auctionStatuses = constants.common.auctionStatus;
  modalRef: BsModalRef;

  sliderErrorLogs: Array<string> = [];
  galleryErrorLogs: Array<string> = [];
  private subscriptions: Array<Subscription> = [];

  constructor(
    private auctionService: AuctionService,
    private toastr: ToastrService,
    private router: Router,
    private loader: LoaderService,
    private auctionImageUploader: AuctionImageUploadService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.initializeSettings();
    this.initiateForm2();
    if (this.auctionId) {
      this.bindFormData();
    } else {
      this.showView = true;
    }
  }

  private initializeSettings() {
    this.coverPhotoSize = constants.admin.uploadSetting.coverPhotoMaxSize;
    this.coverPhotoFormat = constants.admin.uploadSetting.coverPhotoType;
    this.clientLogoSize = constants.admin.uploadSetting.clientLogoMaxSize;
    this.clientLogoFormat = constants.admin.uploadSetting.clientLogoType;

    this.sliderImageSize = constants.admin.uploadSetting.sliderImageMaxSize;
    this.sliderImageFormat = constants.admin.uploadSetting.sliderImageType;
    this.photoGallerySize = constants.admin.uploadSetting.photoGalleryMaxSize;
    this.photoGalleryFormat = constants.admin.uploadSetting.photoGalleryType;

    this.sliderImageAsset = constants.admin.assetType.sliderImage;
    this.photoGalleryAsset = constants.admin.assetType.photoGallery;
  }

  private initiateForm2() {
    this.createAuctionForm2 = new FormGroup({
      coverPhoto: new FormControl(null, [
        ImageValidators.sizeCheck(this.coverPhotoSize),
        ImageValidators.imageFormat(this.coverPhotoFormat),
        this.conditionalRequired.bind(this),
      ]),
      clientLogo: new FormControl(null, [
        ImageValidators.sizeCheck(this.clientLogoSize),
        ImageValidators.imageFormat(this.clientLogoFormat),
        this.conditionalRequired.bind(this),
      ]),
    });
  }

  bindFormData() {
    const step1 = this.auctionService.getAuctionStepIi(this.auctionId).subscribe(
      (res) => {
        this.bindingData(res);
        this.showView = true;
      },
      () => {
        this.showView = true;
        this.onCancel();
      }
    );
    this.subscriptions.push(step1);
  }

  bindingData(value: GetAuctionStep2) {
    this.coverPhotoString = value.coverPhoto;
    this.clientLogoString = value.clientLogo;
    this.createAuctionForm2.patchValue({
      clientLogo: value.clientLogo,
      coverPhoto: value.coverPhoto,
    });
    this.addEditDeleteSliderImages = value.sliderImagesThumbnail;
    this.addEditDeletePhotoGallery = value.photoGalleryThumbnail;
  }

  private conditionalRequired(formControl: FormControl) {
    if (
      this.auctionStatus !== this.auctionStatuses.past ||
      this.auctionStatus !== this.auctionStatuses.archived
    )
      return Validators.required(formControl);
    return null;
  }

  // files handling
  uploadCoverPhoto(files: FileList) {
    let reader = new FileReader();
    this.coverPhotoString = null;
    let control = this.createAuctionForm2.controls.coverPhoto;
    if (files.length > 0) {
      this.createAuctionForm2.patchValue({ coverPhoto: files[0] });
      control.markAsTouched();
      control.updateValueAndValidity();
      if (control.valid) {
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.coverPhotoString = reader.result as string;
        };
      } else {
        this.coverPhotoString = null;
        control.markAsTouched();
      }
    }
  }

  uploadClientLogo(files: FileList) {
    let reader = new FileReader();
    this.clientLogoString = null;
    let control = this.createAuctionForm2.controls.clientLogo;
    if (files.length > 0) {
      this.createAuctionForm2.patchValue({ clientLogo: files[0] });
      control.markAsTouched();
      control.updateValueAndValidity();
      if (control.valid) {
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.clientLogoString = reader.result as string;
        };
      } else {
        this.clientLogoString = null;
        control.markAsTouched();
      }
    }
  }

  onCancel() {
    if (this.auctionStatus == 1) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'live' },
      });
    } else if (this.auctionStatus == 2) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'upcoming' },
      });
    } else if (this.auctionStatus == 4) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'recent' },
      });
    } else {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'pending' },
      });
    }
  }

  goToStep(step: number = 1) {
    this.step.emit(step);
  }

  async save() {
    this.submitted = true;

    if (this.createAuctionForm2.invalid) {
      return;
    }

    let numOfSliderImages = this.resultantSliderImages.length;
    let numOfGalleryImages = this.resultantGalleryImages.length;

    if (
      this.createAuctionForm2.pristine &&
      numOfSliderImages === 0 &&
      numOfGalleryImages === 0
    ) {
      this.formDone();
    }

    this.submitted = false;

    this.loader.showLoader(true);

    let clientImage = this.createAuctionForm2.value.clientLogo;
    let coverImage = this.createAuctionForm2.value.coverPhoto;
    // upload logo and cover photo
    if (typeof clientImage !== 'string' || typeof coverImage !== 'string') {
      let formData = new FormData();
      formData.append('AuctionId', '' + this.auctionId);
      if(clientImage)
      { 
        if(typeof clientImage === 'string')
        {
          formData.append('ClientLogo', clientImage);
        } 
        else
        {
          formData.append('ClientLogo', clientImage, clientImage?.name);
        }
      }
      if(coverImage)
      { 
        if(typeof coverImage === 'string')
        {
          formData.append('CoverPhoto', coverImage);
        } 
        else
        {
          formData.append('CoverPhoto', coverImage, coverImage?.name);
        }
      }
      await this.auctionService.uploadCoverLogoImages(formData).toPromise();
    }

    // upload slider images
    if (this.resultantSliderImages && numOfSliderImages) {
      let failedImages = [];
      this.sliderErrorLogs = [];
      for (let processNum = 1; processNum <= numOfSliderImages; ) {
        let image: ImageFile = this.resultantSliderImages[processNum - 1];
        try {
          await this.auctionImageUploader
            .uploadImage(
              this.auctionId,
              image.id,
              image.name,
              image.order,
              this.sliderImageAsset
            )
            .toPromise();
        } catch (err) {
          processNum++;
          let fileName =
            typeof image.name === 'string' ? image.name : image.name.name;
          this.sliderErrorLogs.push(`issue for image ${fileName} : ${err}`);
          failedImages.push(err);
          continue;
        }
        processNum++;
      }
      if (failedImages && failedImages.length > 0) {
        this.toastr.error(
          'Error(s) occured while uploading images, please see logs',
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      this.loader.showLoader(false);
      return;}
    }

    // upload gallery images
    if (this.resultantGalleryImages && numOfGalleryImages) {
      let failedImages = [];
      this.galleryErrorLogs = [];
      for (let processNum = 1; processNum <= numOfGalleryImages; ) {
        let image: ImageFile = this.resultantGalleryImages[processNum - 1];
        try {
          await this.auctionImageUploader
            .uploadImage(
              this.auctionId,
              image.id,
              image.name,
              image.order,
              this.photoGalleryAsset
            )
            .toPromise();
        } catch (err) {
          processNum++;
          let fileName =
            typeof image.name === 'string' ? image.name : image.name.name;
          this.galleryErrorLogs.push(`issue for image ${fileName} : ${err}`);
          failedImages.push(err);
          continue;
        }
        processNum++;
      }
      if (failedImages && failedImages.length > 0) {
        let msg = failedImages.join('\n');
        this.toastr.error(
          'Error(s) occured while uploading images, please see logs',
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      this.loader.showLoader(false);
      return;}
    }

    this.formDone();
  }

  private formDone() {
    this.sliderImages = [];
    this.galleryImages = [];
    this.clientLogoString = null;
    this.coverPhotoString = null;
    this.loader.showLoader(false);
    this.toastr.success(
      this.editMode ? messages.addAuction2.updated : messages.addAuction2.saved,
      constants.common.toast.successTitle,
      constants.common.toast.config
    );
    this.goToStep(3);
  }
  syncSliderImages() {
    this.loader.showLoader(true);
    const simages = this.auctionService.syncSliderImages(this.auctionId).subscribe(
      (res: any) => {
        if (res) {
          this.toastr.success(
            'Slider Images Upload Successfully.',
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
        } else {
          this.toastr.error(
            'No image added from the server',
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
        }
        this.loader.showLoader(false);
        this.closeModal();
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.loader.showLoader(false);
      }
    );
    this.subscriptions.push(simages);
  }

  syncGalleryImages() {
    this.loader.showLoader(true);
    const gimages = this.auctionService.syncGalleryImages(this.auctionId).subscribe(
      (res: any) => {
        if (res) {
          this.toastr.success(
            'Gallery Images Upload Successfully.',
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
        } else {
          this.toastr.error(
            'No image added from the server',
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
        }
        this.loader.showLoader(false);
        this.closeModal();
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.loader.showLoader(false);
      }
    );
    this.subscriptions.push(gimages);
  }

  closeModal() {
    if (this.modalRef) this.modalRef.hide();
  }

  openSyncSliderModal(template: TemplateRef<any>) {
    if (this.resultantSliderImages.length) {
      let modalOptions: ModalOptions = {
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup delete-modal modal-dialog modal-dialog-centered',
      };
      this.modalRef = this.modalService.show(template, modalOptions);
    } else {
      this.syncSliderImages();
    }
  }

  openSyncGalleryModal(template: TemplateRef<any>) {
    if (this.resultantGalleryImages.length) {
      let modalOptions: ModalOptions = {
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup delete-modal modal-dialog modal-dialog-centered',
      };
      this.modalRef = this.modalService.show(template, modalOptions);
    } else {
      this.syncGalleryImages();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
